<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routerParams = ref({
  name: 'inbox_conversation',
  params: { conversation_id: props.row.original.conversationId },
});
watch(
  () => props.row,
  newRow => {
    routerParams.value = {
      name: 'inbox_conversation',
      params: { conversation_id: newRow.original.conversationId },
    };
  },
  { immediate: true }
);
</script>

<template>
  <div class="text-right">
    <router-link :to="routerParams" class="hover:underline">
      {{ `#${props.row.original.conversationId}` }}
    </router-link>
    <div
      v-tooltip="props.row.original.createdAt"
      class="text-slate-600 dark:text-slate-200 text-sm"
    >
      {{ props.row.original.createdAgo }}
    </div>
  </div>
</template>
